import React from 'react'
import {
  faAdd,
  faAt,
  faHouse,
  faPencilAlt,
  faPhone,
  faUser,
} from '@fortawesome/free-solid-svg-icons'
import {
  $DCprimaryColor,
  DcButton,
  DcFlexBox,
  DcOverlaySlider,
  PixelIcon,
  PixelText,
} from 'pixel-base'

import {
  Address,
  Country,
  Customer,
  OrderDetail,
} from '../../../../../../../decl'
import AddNewAddress from '../../../../../customers/pages/details/components/components/AddNewAddress'
import EditCustomerAddress from '../../../../../customers/pages/details/components/components/EditCustomerAddress'
interface IProps {
  address: Address
  customerId: number
  countries: Country[]
  addressType: string
  isItInvoice: boolean
  customerData: Customer
  newOrder: boolean
  setAddresses: (addresses: Address[]) => void
  details: OrderDetail
  origin: string
  orderId: number
  invoiceStatus: string
}
const CustomerAddresses = (props: IProps) => {
  const {
    address,
    customerId,
    countries,
    addressType,
    isItInvoice,
    customerData,
    newOrder,
    setAddresses,
    details,
    origin,
    orderId,
    invoiceStatus,
  } = props

  const [showCustomerInfoPopup, setShowCustomerInfoPopup] =
    React.useState(false)
  const [showAddNewAddressPopup, setShowAddNewAddressPopup] =
    React.useState(false)

  return (
    <>
      <>
        <DcFlexBox
          style={{
            flexDirection: 'column',
            alignContent: 'center',
            borderBottom: '1px solid #e6e6e6',
            width: '100%',
            padding: '10px 0px',
          }}
        >
          {
            <DcFlexBox
              style={{
                justifyContent: 'space-between',
              }}
            >
              <PixelText
                textSize="16px"
                color="rgba(0, 0, 0, 0.84)"
                style={{ fontWeight: '600', padding: '10px' }}
              >
                {addressType === 'billing' ? 'Billing' : 'Shipping'} Address
              </PixelText>

              <>
                <DcFlexBox
                  style={{
                    padding: '10px',
                    cursor: 'pointer',
                    color: 'rgba(0, 0, 0, 0.84)',
                    fontSize: '20px',
                    fontWeight: '600',
                    gap: '10px',
                    heigh: 'auto',
                    width: 'auto',
                  }}
                >
                  {!address && isItInvoice && !newOrder && (
                    <DcButton
                      variant="link"
                      onClick={() => {
                        setShowAddNewAddressPopup(true)
                      }}
                    >
                      <PixelIcon
                        color={$DCprimaryColor}
                        showTooltip
                        tooltip="Add"
                        icon={faAdd}
                      />
                    </DcButton>
                  )}
                  {isItInvoice || details.is_editable
                    ? address !== undefined &&
                      (invoiceStatus == 'closed' ? (
                        <DcButton
                          variant="link"
                          size="sm"
                          style={{
                            border: 'none',
                            cursor: 'not-allowed',
                          }}
                        >
                          <PixelIcon
                            color={$DCprimaryColor}
                            showTooltip
                            tooltip="Edit"
                            icon={faPencilAlt}
                          />
                        </DcButton>
                      ) : (
                        <DcButton
                          variant="link"
                          size="sm"
                          onClick={() => {
                            setShowCustomerInfoPopup(true)
                          }}
                        >
                          <PixelIcon
                            color={$DCprimaryColor}
                            showTooltip
                            tooltip="Edit"
                            icon={faPencilAlt}
                          />
                        </DcButton>
                      ))
                    : ''}
                </DcFlexBox>
              </>
            </DcFlexBox>
          }

          {address !== undefined && (
            <DcFlexBox style={{ flexDirection: 'column', marginLeft: '10px' }}>
              <DcFlexBox
                style={{
                  justifyContent: 'flex-start',
                  marginTop: '3px',
                  gap: '7px',
                }}
              >
                <div>
                  <PixelIcon
                    style={{ marginBottom: '10px' }}
                    color="#000"
                    icon={faUser}
                  />
                </div>
                <div
                  style={{ fontSize: '12px', fontWeight: '400', color: '#000' }}
                >
                  {address?.first_name}
                  &nbsp;
                  {address?.last_name}
                </div>
              </DcFlexBox>
              <DcFlexBox
                style={{
                  justifyContent: 'flex-start',
                  marginTop: '3px',
                  gap: '5px',
                }}
              >
                <div>
                  <PixelIcon
                    style={{ marginBottom: '10px' }}
                    color="#000"
                    icon={faPhone}
                  />
                </div>
                <div
                  style={{ fontSize: '12px', fontWeight: '400', color: '#000' }}
                >
                  {address?.phone}
                </div>
              </DcFlexBox>

              <DcFlexBox
                style={{
                  justifyContent: 'flex-start',
                  marginTop: '3px',
                  gap: '7px',
                }}
              >
                <div>
                  <PixelIcon
                    style={{ marginBottom: '10px' }}
                    color="#000"
                    icon={faAt}
                  />
                </div>
                <div
                  style={{ fontSize: '12px', fontWeight: '400', color: '#000' }}
                >
                  {isItInvoice ? customerData.email : address.email}
                </div>
              </DcFlexBox>

              <DcFlexBox
                style={{
                  justifyContent: 'flex-start',
                  marginTop: '3px',
                  gap: '4px',
                }}
              >
                <div>
                  <PixelIcon
                    style={{ marginBottom: '10px' }}
                    color="#000"
                    icon={faHouse}
                  />
                </div>
                <div
                  style={{ fontSize: '12px', fontWeight: '400', color: '#000' }}
                >
                  {address?.address1} &nbsp;
                  <strong>
                    {address?.city}-{address?.state} -
                    {address?.zip || address?.postcode}-
                    {newOrder ? address?.country_name : address?.country}
                  </strong>
                </div>
              </DcFlexBox>
            </DcFlexBox>
          )}
        </DcFlexBox>
      </>
      <DcOverlaySlider
        isOpen={showCustomerInfoPopup}
        onClose={() => setShowCustomerInfoPopup(false)}
        title={`Edit ${
          addressType === 'billing' ? 'Billing' : 'Shipping'
        } Address`}
        width="50%"
      >
        {showCustomerInfoPopup && (
          <EditCustomerAddress
            address={address}
            countries={countries}
            customer_id={customerId}
            addressType={addressType}
            origin={origin}
            source_order_id={orderId}
            handleClose={(data) => {
              if (data) {
                addressType === 'billing'
                  ? setAddresses((prevAddresses) => [
                      {
                        billingAddress: { ...data, address_type: 'billing' },
                      },
                      prevAddresses[1],
                    ])
                  : setAddresses((prevAddresses) => [
                      prevAddresses[0],
                      {
                        shippingAddress: { ...data, address_type: 'shipping' },
                      },
                    ])
              }

              setShowCustomerInfoPopup(false)
            }}
          />
        )}
      </DcOverlaySlider>
      <DcOverlaySlider
        isOpen={showAddNewAddressPopup}
        onClose={() => setShowAddNewAddressPopup(false)}
        title={`Add  ${addressType} Address`}
        width="50%"
      >
        {showAddNewAddressPopup && (
          <AddNewAddress
            customer_id={customerId}
            address_id={address?.address_id}
            addressType={addressType}
            handleClose={(data) => {
              addressType === 'billing'
                ? setAddresses((prevAddresses) => [
                    {
                      billingAddress: { ...data, address_type: 'billing' },
                    },
                    prevAddresses[1],
                  ])
                : setAddresses((prevAddresses) => [
                    prevAddresses[0],
                    {
                      shippingAddress: { ...data, address_type: 'shipping' },
                    },
                  ])
              setShowAddNewAddressPopup(false)
            }}
            countries={countries}
          />
        )}
      </DcOverlaySlider>
    </>
  )
}

export default CustomerAddresses
